interface IAversaryCardProps {
  reportName: string
  execSummary: string
  downloadLink: string
  downloadTitle: string
  downloadAction: (reportName: string) => void
  reportImage?: string
  reportDate?: string
}

function AdversaryCard(props: IAversaryCardProps) {
  const { reportName, reportImage, execSummary, downloadLink, downloadTitle, downloadAction, reportDate } = props

  return (
    <div
      key={reportName}
      className="border border-mainBorder rounded-lg p-4 bg-cardFill grid grid-rows-[1fr_auto] h-full"
    >
      <div>
        {reportImage && <img src={reportImage} alt={reportName} className="w-full h-[220px] object-cover rounded" />}
        {reportDate && (
          <p className="text-xs inline-block align-bottom text-neutral-10 font-medium mt-2.5">{reportDate}</p>
        )}
        <p className={`font-medium ${reportDate ? '' : 'mt-2.5'}`}>{reportName}</p>
        <p className="text-xs mt-3">{execSummary}</p>
      </div>
      <div className="flex justify-end mt-3">
        <div
          role="button"
          className="h-8 px-3 bg-neutral-1 dark:bg-transparent rounded border border-neutral-5 justify-center items-center gap-2 inline-flex"
          onClick={() => downloadAction(downloadLink)}
        >
          <div className="text-paginationSelected text-sm leading-tight">{downloadTitle}</div>
        </div>
      </div>
    </div>
  )
}

export default AdversaryCard
